import { useId } from "@react-aria/utils"
import PropTypes from "prop-types"
import { useState } from "react"

import ProductCard from "areas/landing/elements/landing-product/product-card"
import Button from "components/ui/button"
import Expand from "components/ui/expand"

const ShopTheLookExpand = ({ element, products }) => {
  const [expand, setExpand] = useState(false)
  const expandId = useId()

  return (
    <>
      <div className="grid grid-cols-2 gap-x-8 gap-y-16 overflow-hidden">
        {products.slice(0, 4).map((product, i) => (
          <ProductCard
            element={element}
            index={i}
            key={`${product.style_code}-${i}`}
            product={product}
          />
        ))}
      </div>
      <Expand className="mt-24" id={expandId} show={expand}>
        <div className="grid grid-cols-2 gap-x-8 gap-y-16 overflow-hidden">
          {products.slice(4).map((product, i) => (
            <ProductCard
              element={element}
              index={i + 4}
              key={`${product.style_code}-${i}`}
              product={product}
            />
          ))}
        </div>
      </Expand>
      <div className="mx-auto mt-16 text-center">
        <Button
          aria-controls={expandId}
          aria-expanded={expand}
          onClick={() => setExpand(!expand)}
          variant="tertiary"
        >
          View {expand ? "Less" : "More"}
        </Button>
      </div>
    </>
  )
}

ShopTheLookExpand.propTypes = {
  element: PropTypes.object,
  products: PropTypes.array,
}

export default ShopTheLookExpand
